import { Backdrop, CircularProgress } from '@mui/material';
import useHidePageScroll from 'v2/core/hooks/useHidePageScroll';
import useFullscreenLoaderStore, {
  FullscreenLoaderStore,
} from 'v2/store/useFullscreenLoaderStore';

const getFullscreenLoaderStoreData = (state: FullscreenLoaderStore) => ({
  isFullscreenLoaderVisible: state.isLoading,
  isInvisible: state.isInvisible,
});

const FullscreenLoader = () => {
  const { isFullscreenLoaderVisible, isInvisible } = useFullscreenLoaderStore(
    getFullscreenLoaderStoreData,
  );
  useHidePageScroll(isFullscreenLoaderVisible);

  if (!isFullscreenLoaderVisible) {
    return <></>;
  }

  return (
    <Backdrop
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      invisible={isInvisible}
      open={true}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default FullscreenLoader;
